import { SidebarNav } from "./SidebarNav";
import { useAppearance } from "@/lib/appearance";
import { cn } from "@/lib/utils";

export function AppSidebar() {
  const { sidebarFixed } = useAppearance();

  return (
    <aside
      className={cn(
        "hidden md:flex w-64 shrink-0 flex-col border-r border-sidebar-border bg-sidebar",
        // Sidebar fijo: permanece pegado al viewport. Si se desactiva, hace
        // scroll junto al contenido y libera altura en pantallas pequeñas.
        sidebarFixed ? "sticky top-0 h-screen overflow-y-auto" : "relative",
      )}
    >
      <SidebarNav />
    </aside>
  );
}
